import React from 'react';
import GroupList from '../../../components/Protocols/Groups/GroupList';

const GroupListContainer = ({ groups, onSelect, isLoading, editGroupButton, duplicateGroupButton }) => {
    return (
        <GroupList groups={groups} onSelect={onSelect} isLoading={isLoading} editGroupButton={editGroupButton} duplicateGroupButton={duplicateGroupButton } />
    );
};

export default GroupListContainer;